import { useContext } from "react";
import TableFilterContext from "./TableFilterContext";
const useTableFilterContext = () => {
  const contextValue = useContext(TableFilterContext);
  if (!contextValue) {
    throw new Error("useTableFilterContext hook needs to be used inside TableFilterContext.Provider");
  }
  return contextValue;
};
export default useTableFilterContext;
